import { gql, useQuery } from '@apollo/client'


export interface GetDeviceAdminTokenQuery {
  getDeviceAdminToken: string
}


export const GQL_QUERY_GET_DEVICE_ADMIN_TOKEN = gql`
  query getDeviceAdminToken {
    getDeviceAdminToken
  }
`

export const useFetchGetDeviceAdminToken = () => useQuery<GetDeviceAdminTokenQuery>(
  GQL_QUERY_GET_DEVICE_ADMIN_TOKEN,
  {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  }
)